import { BaseQueryFn } from '@reduxjs/toolkit/query';
import axios, { AxiosRequestConfig, AxiosError } from 'axios';

import { environment } from 'environments';

type ReturnBaseQueryFn = BaseQueryFn<BaseQueryFnParams, unknown, unknown>;

type BaseQueryFnParams = {
  url: string;
  method: AxiosRequestConfig['method'];
  body?: AxiosRequestConfig['data'];
  params?: AxiosRequestConfig['params'];
  paramsSerializer?: AxiosRequestConfig['paramsSerializer'];
};

export const baseQuery: ReturnBaseQueryFn = async ({ url, method, body, params, paramsSerializer }) => {
  try {
    const result = await axios({ url: environment.baseApiUrl + url, method, data: body, params, paramsSerializer });

    return { data: result.data };
  } catch (axiosError) {
    const err = axiosError as AxiosError;

    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    };
  }
};
